module.exports = __webpack_public_path__ + "static/media/folder-check.cb00eee5.svg";